import Icon from 'components/Icon'
import CheckMarkIcon from 'components/Icon/icons/check-mark'
import { View } from 'components/View'
import {
  FEATURE_MESSAGES,
  PREMIUM_PLUS_FEATURE_MESSAGES
} from 'modules/app/constants/features'
import {
  STYLES_COLOR,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import SubscriptionPlanFeatureLine from 'pages/Premium/FreeVsPremiumFeatures/SubscriptionPlans/FeatureLine/index.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import TextBodySmall from 'components/TextBodySmall/index.js'
// import logEventAnalyticsUtil from 'modules/analytics/utils/log-event/index.js'
//
// const ANALYTIC_EVENT = {
//   SHOW_MORE_PREMIUM_PLUS_FEATURES: 'SHOW_MORE_PREMIUM_PLUS_FEATURES'
// }

const messages = defineMessages({
  andMuchMore: {
    id: 'SubscriptionPremiumPlusPlanFeatures.andMuchMore',
    defaultMessage: 'And much more...'
  },
  includesAllPremiumFeatures: {
    id: 'SubscriptionPremiumPlusPlanFeatures.includesAllPremiumFeatures',
    defaultMessage: 'Includes all Premium ⭐️ features, plus:'
  }
})

const MAIN_FEATURES_COUNT = 2

/**
 * @param props
 * @param props.areFeaturesPressable
 * @param props.isSummary
 * @param props.shouldBoldMainFeatures
 * @returns {Element}
 * @constructor
 */
export function SubscriptionPremiumPlusPlanFeatures (props) {
  const {
    isSummary,
    areFeaturesPressable,
    shouldBoldMainFeatures
  } = props
  const intl = useIntl()

  // const [showMuchMoreMessages, setShowMuchMoreMessages] = React.useState(false)
  const messagesArr = isSummary
    ? [
        ...PREMIUM_PLUS_FEATURE_MESSAGES.slice(0, MAIN_FEATURES_COUNT),
        messages.andMuchMore
      ]
    : FEATURE_MESSAGES
  // const muchMoreMessages = PREMIUM_PLUS_FEATURE_MESSAGES.slice(MAIN_FEATURES_COUNT)

  const messagesArrToShow = messagesArr
  // if (showMuchMoreMessages) {
  //   messagesArrToShow = [
  //     ...messagesArr.slice(0, MAIN_FEATURES_COUNT),
  //     ...muchMoreMessages
  //   ]
  // } else {
  //   messagesArrToShow = messagesArr
  // }

  // const handlePressMuchMore = (event) => {
  //   event.preventDefault()
  //   logEventAnalyticsUtil(ANALYTIC_EVENT.SHOW_MORE_PREMIUM_PLUS_FEATURES)
  //   setShowMuchMoreMessages(!showMuchMoreMessages)
  // }

  return (
    <View>
      {
        !!isSummary && (
          <TextBodySmall
            c='paragraph'
            style={{
              textAlign: 'left'
            }}
          >
            {formatMessageIntlUtil(intl, messages.includesAllPremiumFeatures)}
          </TextBodySmall>
        )
      }

      {
        messagesArrToShow.map((
          message,
          index
        ) => {
          const isMuchMore = message === messages.andMuchMore
          const isChecked = (
            PREMIUM_PLUS_FEATURE_MESSAGES.includes(message) ||
            isMuchMore
          )

          return (
            <View
              key={index}
              style={{
                flexDirection: View.DIRECTION.ROW,
                lineHeight: '1em',
                opacity: isChecked ? '1' : '0.3'
              }}
              mt={1.5}
            >
              <div
                style={{
                  paddingRight: STYLES_PADDING.SMALL,
                  color: STYLES_COLOR.BLUE
                }}
              >
                <Icon
                  icon={CheckMarkIcon}
                  size={Icon.SIZE.SMALLER}
                />
              </div>

              <SubscriptionPlanFeatureLine
                areFeaturesPressable={areFeaturesPressable}
                message={message}
                // isMuchMore={isMuchMore}
                // onPressMuchMore={handlePressMuchMore}
                isBold={shouldBoldMainFeatures && index < MAIN_FEATURES_COUNT}
              />
            </View>
          )
        })
      }
    </View>
  )
}
